import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState: number[] = [];

export const TableReservationsSlice = createSlice({
    name: 'tableReservations',
    initialState,
    reducers: {
        setTableReservations: (state, action: PayloadAction<number[]>) => {
            return action.payload;
        },

        resetTableReservations: () => initialState,
    },
});

export const { setTableReservations, resetTableReservations } =
    TableReservationsSlice.actions;

export const selectTableReservations = (state: RootState) =>
    state.tableReservations;

export const TableReservationsReducer = TableReservationsSlice.reducer;
